import { render, staticRenderFns } from "./DealWrapper.vue?vue&type=template&id=906ee4f8&scoped=true&"
import script from "./DealWrapper.vue?vue&type=script&lang=js&"
export * from "./DealWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906ee4f8",
  null
  
)

export default component.exports